const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
"https://srinivasafleet.com/api";

const getToken = () => {
  const keys = [
    "token",
    "access_token",
    "accessToken",
    "auth_token",
    "authToken",
    "admin_token",
  ];

  for (const key of keys) {
    const localValue = localStorage.getItem(key);

    if (
      localValue &&
      localValue !== "null" &&
      localValue !== "undefined"
    ) {
      return localValue;
    }

    const sessionValue = sessionStorage.getItem(key);

    if (
      sessionValue &&
      sessionValue !== "null" &&
      sessionValue !== "undefined"
    ) {
      return sessionValue;
    }
  }

  return "";
};
const request = async (url, options = {}) => {
  const token = getToken();

  const headers = {
    Accept: "application/json",

    ...(options.body
      ? {
          "Content-Type": "application/json",
        }
      : {}),

    ...(token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {}),

    ...(options.headers || {}),
  };

  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers,
  });

  let data = null;

  const contentType =
    response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    try {
      data = await response.json();
    } catch {
      data = null;
    }
  } else {
    try {
      const text = await response.text();
      data = text || null;
    } catch {
      data = null;
    }
  }

  if (!response.ok) {
    let message =
      `Request failed with status ${response.status}`;

    if (Array.isArray(data?.detail)) {
      message = data.detail
        .map(
          (item) =>
            item?.msg ||
            item?.message ||
            String(item)
        )
        .join(", ");
    } else if (
      typeof data?.detail === "string"
    ) {
      message = data.detail;
    } else if (
      typeof data?.message === "string"
    ) {
      message = data.message;
    } else if (
      typeof data === "string" &&
      data
    ) {
      message = data;
    }

    throw new Error(message);
  }

  return data;
};


const normalizeAmount = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return 0;
  }

  const amount = Number(value);

  return Number.isFinite(amount)
    ? amount
    : 0;
};

const normalizeCab = (data) => {
  const item = data || {};

  return {
    outstandingSupplierId:
      item.outstanding_supplier_id ??
      item.outstandingSupplierId ??
      null,

    supplierId:
      item.supplier_id ??
      item.supplierId ??
      null,

    vehicleAssignmentId:
      item.vehicle_assignment_id ??
      item.vehicleAssignmentId ??
      null,

    vehicleId:
      item.vehicle_id ??
      item.vehicleId ??
      null,

    cabNumber:
      item.vehicle_registration_number ||
      item.vehicle_display_number ||
      item.cabNumber ||
      "",

    vehicleRegistrationNumber:
      item.vehicle_registration_number ||
      item.vehicleRegistrationNumber ||
      "",

    vehicleDisplayNumber:
      item.vehicle_display_number ||
      item.vehicleDisplayNumber ||
      "",

    supplier:
      item.supplier_name ||
      item.supplier ||
      "",

    driver:
      item.driver_name ||
      item.driver ||
      "",

    supplierMobile:
      item.supplier_mobile ||
      item.supplierMobile ||
      "",

    driverMobile:
      item.driver_mobile ||
      item.driverMobile ||
      "",

    contacts: [
      item.driver_mobile,
      item.driverMobile,
      item.supplier_mobile,
      item.supplierMobile,
    ].filter(Boolean),

    vehicleType:
      item.vehicle_type ||
      item.vehicle_type_name ||
      item.vehicleType ||
      "",

    year:
      item.year ?? "",

    outstandingAmount: normalizeAmount(
      item.outstanding_amount ??
      item.outstandingAmount
    ),

    dueDate:
      item.due_date ||
      item.dueDate ||
      "",
  };
};

const normalizeRecord = (data) => {
  const item = data || {};

  return {
    id: item.id,

    outstandingSupplierId:
      item.outstanding_supplier_id ??
      item.outstandingSupplierId ??
      null,

    supplierId:
      item.supplier_id ??
      item.supplierId ??
      null,

    vehicleAssignmentId:
      item.vehicle_assignment_id ??
      item.vehicleAssignmentId ??
      null,

    vehicleId:
      item.vehicle_id ??
      item.vehicleId ??
      null,

    date:
      item.followup_date ||
      item.followupDate ||
      "",

    outstandingAmount:
      normalizeAmount(
        item.outstanding_amount ??
        item.outstandingAmount
      ),

    dueDate:
      item.due_date ||
      item.dueDate ||
      "",

    remarks:
      item.remarks || "",

    status:
      item.status ||
      "Pending",

    smsSent: Boolean(
      item.sms_sent ??
      item.smsSent
    ),

    smsSentAt:
      item.sms_sent_at ||
      item.smsSentAt ||
      null,

    paidAt:
      item.paid_at ||
      item.paidAt ||
      null,

    cabNumber:
      item.vehicle_registration_number ||
      item.vehicle_display_number ||
      item.cabNumber ||
      "",

    vehicleRegistrationNumber:
      item.vehicle_registration_number ||
      item.vehicleRegistrationNumber ||
      "",

    vehicleDisplayNumber:
      item.vehicle_display_number ||
      item.vehicleDisplayNumber ||
      "",

    supplier:
      item.supplier_name ||
      item.supplier ||
      "",

    driver:
      item.driver_name ||
      item.driver ||
      "",

    supplierMobile:
      item.supplier_mobile ||
      item.supplierMobile ||
      "",

    driverMobile:
      item.driver_mobile ||
      item.driverMobile ||
      "",

    contacts: [
      item.driver_mobile,
      item.driverMobile,
      item.supplier_mobile,
      item.supplierMobile,
    ].filter(Boolean),

    vehicleType:
      item.vehicle_type ||
      item.vehicleType ||
      "",

    year:
      item.year ?? "",

    createdBy:
      item.created_by ??
      item.createdBy ??
      null,

    createdByName:
      item.created_by_name ||
      item.createdByName ||
      "",

    updatedBy:
      item.updated_by ??
      item.updatedBy ??
      null,

    updatedByName:
      item.updated_by_name ||
      item.updatedByName ||
      "",

    createdAt:
      item.created_at ||
      item.createdAt ||
      null,

    updatedAt:
      item.updated_at ||
      item.updatedAt ||
      "",

    smsMessage:
      item.sms_message ||
      item.smsMessage ||
      "",

    smsMobile:
      item.sms_mobile ||
      item.smsMobile ||
      "",
  };
};

export const searchOutstandingCab = async ({
  cabLast4,
  followupDate,
}) => {
  const cleanLast4 = String(cabLast4 || "")
    .replace(/\D/g, "")
    .slice(0, 4);

  if (cleanLast4.length !== 4) {
    throw new Error(
      "Enter exactly 4 digits of the cab number."
    );
  }

  if (!followupDate) {
    throw new Error(
      "Follow-up date is required."
    );
  }

  const data = await request(
    "/outstanding-followups/search-cab",
    {
      method: "POST",

      body: JSON.stringify({
        cab_last_4: cleanLast4,
        followup_date: followupDate,
      }),
    }
  );

  return normalizeCab(data);
};

export const getOutstandingFollowups = async ({
  fromDate = "",
  toDate = "",
  supplierId = "",
  status = "",
} = {}) => {
  const params = new URLSearchParams();

  if (fromDate) {
    params.set(
      "from_date",
      fromDate
    );
  }

  if (toDate) {
    params.set(
      "to_date",
      toDate
    );
  }

  if (supplierId) {
    params.set(
      "supplier_id",
      String(supplierId)
    );
  }

  if (status) {
    params.set(
      "status",
      status
    );
  }

  const query = params.toString();

  const data = await request(
    `/outstanding-followups/${
      query ? `?${query}` : ""
    }`
  );

  if (!Array.isArray(data)) {
    return [];
  }

  return data.map(normalizeRecord);
};

export const createOutstandingFollowup =
  async (payload) => {
    if (!payload?.outstandingSupplierId) {
      throw new Error(
        "Outstanding supplier record is required."
      );
    }

    if (!payload?.supplierId) {
      throw new Error(
        "Supplier is required."
      );
    }

    if (!payload?.vehicleAssignmentId) {
      throw new Error(
        "Vehicle assignment is required."
      );
    }

    if (!payload?.vehicleId) {
      throw new Error(
        "Vehicle is required."
      );
    }

    if (!payload?.followupDate) {
      throw new Error(
        "Follow-up date is required."
      );
    }

    if (!payload?.dueDate) {
      throw new Error(
        "Due date is required."
      );
    }

    const body = {
      outstanding_supplier_id:
        Number(
          payload.outstandingSupplierId
        ),

      supplier_id:
        Number(
          payload.supplierId
        ),

      vehicle_assignment_id:
        Number(
          payload.vehicleAssignmentId
        ),

      vehicle_id:
        Number(
          payload.vehicleId
        ),

      followup_date:
        payload.followupDate,

      due_date:
        payload.dueDate,

      outstanding_amount:
        payload.outstandingAmount !==
        undefined &&
        payload.outstandingAmount !== null
          ? Number(
              payload.outstandingAmount
            )
          : undefined,

      remarks: "",
    };

    const data = await request(
      "/outstanding-followups/",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );

    return normalizeRecord(data);
  };


export const updateOutstandingFollowup =
  async (
    followupId,
    payload
  ) => {
    if (!followupId) {
      throw new Error(
        "Outstanding follow-up ID is required."
      );
    }

    const body = {};

    if (payload?.followupDate) {
      body.followup_date =
        payload.followupDate;
    }

    if (payload?.dueDate) {
      body.due_date =
        payload.dueDate;
    }

    if (
      payload?.outstandingAmount !==
        undefined &&
      payload?.outstandingAmount !==
        null
    ) {
      body.outstanding_amount =
        Number(
          payload.outstandingAmount
        );
    }

    body.remarks = "";

    const data = await request(
      `/outstanding-followups/${encodeURIComponent(
        followupId
      )}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      }
    );

    return normalizeRecord(data);
  };


export const markOutstandingSmsSent =
  async (followupId) => {
    if (!followupId) {
      throw new Error(
        "Outstanding follow-up ID is required."
      );
    }

    const data = await request(
      `/outstanding-followups/${encodeURIComponent(
        followupId
      )}/send-sms`,
      {
        method: "POST",
        body: JSON.stringify({}),
      }
    );

    return data;
  };


export const markOutstandingPaid =
  async (followupId) => {
    if (!followupId) {
      throw new Error(
        "Outstanding follow-up ID is required."
      );
    }

    const data = await request(
      `/outstanding-followups/${encodeURIComponent(
        followupId
      )}/mark-paid`,
      {
        method: "POST",
      }
    );

    return normalizeRecord(data);
  };


export default {
  searchOutstandingCab,
  getOutstandingFollowups,
  createOutstandingFollowup,
  updateOutstandingFollowup,
  markOutstandingSmsSent,
  markOutstandingPaid,
};